import React, { useEffect, useContext } from 'react';
import AOS from 'aos';
import CountUp from 'react-countup';
import 'aos/dist/aos.css';
import { LanguageContext } from '../Context/LanguageContext';

function CallToAction() {
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const stats = [
    { label: { en: 'Apps Developed', ar: 'تطبيقات مطورة' }, value: 100 },
    { label: { en: 'Years of Experience', ar: 'سنوات خبرة' }, value: 5 },
    { label: { en: 'Happy Clients', ar: 'عملاء سعداء' }, value: 100 },
    { label: { en: 'Team Members', ar: 'أعضاء الفريق' }, value: 20 },
  ];

  return (
    <div
      className="call-to-action position-relative text-center py-2"
      dir={language === 'ar' ? 'rtl' : 'ltr'}
    >
      <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="col-12 col-sm-6 col-md-3 mb-4"
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="stat-box py-4 px-3 h-100 d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex align-items-center gap-1 mb-2">
                  <span className="count-symbol">+</span>
                  <CountUp
                    end={stat.value}
                    duration={2}
                    enableScrollSpy
                    scrollSpyOnce
                    className="count-number"
                  />
                </div>
                <h5 className="stat-label">{stat.label[language]}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>

      {/* Scoped Styles */}
      <style>{`
        .call-to-action {
          background-image: url('/assets/images/bg5.png');
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          color: white;
        }

        .overlay {
           background: RGB(8, 18, 28);
  background: linear-gradient(17deg, rgba(8, 18, 28, 0.916) 48%, rgba(56, 34, 42, 0.889) 100%);
          z-index: 1;
        }

        .stat-box {
          position: relative;
          z-index: 2;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
        }

        .stat-label {
          color: #fff;
          font-size: 1.1rem;
          font-weight: 500;
        }

        .count-number {
          color: #fff;
          font-size: 2.5rem;
          font-weight: bold;
        }

        .count-symbol {
          font-size: 2.5rem;
          color: #fff;
        }

        @media (max-width: 767.98px) {
          .stat-box {
            border-right: none;
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
          }
        }
      `}</style>
    </div>
  );
}

export default CallToAction;
